if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');

      if (!this.elements.viewer) return;

      // Safe debounced slide handler
      const onSlide = this.onSlideChanged.bind(this);
      const debouncedSlide = typeof debounce === 'function' ? debounce(onSlide, 500) : onSlide;
      this.elements.viewer.addEventListener('slideChanged', debouncedSlide);

      // Event Delegation: One listener for all thumbnails instead of N button listeners
      if (this.elements.thumbnails) {
        this.elements.thumbnails.addEventListener('click', (event) => {
          const mediaTarget = event.target.closest('[data-target]');
          if (mediaTarget?.dataset?.target) {
            this.setActiveMedia(mediaTarget.dataset.target, false);
          }
        });
      }

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      const mediaId = event.detail?.currentElement?.dataset?.mediaId;
      if (!mediaId || !this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer?.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      // Single-pass active class toggle
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('is-active', element === activeMedia);
      });

      if (prepend) {
        activeMedia.parentElement?.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail?.parentElement?.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();

      // Smooth frame-aligned layout scroll
      requestAnimationFrame(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement?.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((button) => {
        button.removeAttribute('aria-current');
      });

      const currentBtn = thumbnail.querySelector('button');
      if (currentBtn) currentBtn.setAttribute('aria-current', 'true');

      // Defensive check for custom element slider helpers
      if (typeof this.elements.thumbnails.isSlideVisible === 'function' && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        return;
      }

      this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;

      const updateLiveRegion = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        const templateStr = window.accessibilityStrings?.imageAvailable || 'Image [index]';
        this.elements.liveRegion.innerHTML = templateStr.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion?.setAttribute('aria-hidden', 'true');
        }, 2000);
      };

      // Handle both cached images and freshly loaded images
      if (image.complete) {
        updateLiveRegion();
      } else {
        image.onload = updateLiveRegion;
      }
    }

    playActiveMedia(activeItem) {
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer?.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
    }
  });
}